module.exports = __webpack_public_path__ + "img/avatar-s-10.bd9382ad.jpg";